var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtanddesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 877.51 877.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "226.72 759.69 226.72 664.84 438.76 191.71 654.91 651.57 654.91 759.69 441.59 849.69 226.72 759.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M843.76,438.76c-.05-223.68-181.42-404.96-405.09-404.91-223.68.05-404.96,181.42-404.91,405.09.03,144.66,77.22,278.32,202.5,350.65v-148.33l202.5-438.75,202.5,438.75v148.33c125.34-72.36,202.53-206.11,202.5-350.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749,128.51c-171.34-171.34-449.15-171.34-620.49,0-171.34,171.34-171.34,449.15,0,620.49,171.34,171.34,449.15,171.34,620.49,0s171.34-449.15,0-620.49M270.01,708.76c0-37.28,30.22-67.5,67.5-67.5s67.5,30.22,67.5,67.5v99.52c-47.07-4.26-92.89-17.46-135-38.9v-60.62ZM472.51,708.76c0-37.28,30.22-67.5,67.5-67.5s67.5,30.22,67.5,67.5v60.62c-42.11,21.44-87.93,34.64-135,38.9v-99.52ZM351.3,472.51h174.91l48.85,105.89c-49.58-13.36-102.44,2.62-136.31,41.22-33.87-38.6-86.73-54.58-136.31-41.22l48.85-105.89ZM382.48,405.01l56.28-121.96,56.28,121.96h-112.56ZM701.25,701.29c-8.44,8.44-17.21,16.33-26.24,23.79v-83.83c0-4.88-1.06-9.71-3.12-14.13l-202.5-438.75c-7.83-16.92-27.89-24.28-44.8-16.45-7.26,3.36-13.09,9.19-16.45,16.45l-202.5,438.75c-2.06,4.43-3.13,9.25-3.12,14.13v83.83c-9.12-7.51-17.87-15.45-26.24-23.79-144.99-144.97-145.02-380.03-.05-525.03,144.97-144.99,380.03-145.02,525.03-.05,144.99,144.97,145.02,380.03.05,525.03l-.05.05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtanddesign);
export default __webpack_public_path__ + "static/media/artanddesign.ca781adec5b76f93627394dc11528438.svg";
export { ForwardRef as ReactComponent };